// extracted by mini-css-extract-plugin
export default {"srOnly":"zGFQ3","branding":"QF+AI","upgradePopup":"nTz0U","upgradePopupText":"facJ9","upgradePopupButton":"VsPU0"};